module.exports = __webpack_public_path__ + "static/sonia-report-en-b3f3d3c22e32972a6f91746f695e43dc.png";